import { InjectionToken } from '@angular/core';
import {
  Analytics,
  logEvent,
  setUserProperties,
} from '@angular/fire/analytics';

export type LogEventFn = (
  analytics: Analytics,
  name: string,
  params?: Record<string, unknown>,
) => void;

export type SetUserPropertiesFn = (
  analytics: Analytics,
  properties: Record<string, unknown>,
) => void;

/**
 * Wrap the @angular/fire named export so tests can override the token.
 * Spying on the named export directly fails (non-configurable getter).
 */
export const ANALYTICS_LOG_EVENT = new InjectionToken<LogEventFn>(
  'ANALYTICS_LOG_EVENT',
  {
    providedIn: 'root',
    factory: () =>
      ((analytics, name, params) =>
        logEvent(analytics, name as never, params as never)) as LogEventFn,
  },
);

export const ANALYTICS_SET_USER_PROPERTIES = new InjectionToken<SetUserPropertiesFn>(
  'ANALYTICS_SET_USER_PROPERTIES',
  {
    providedIn: 'root',
    factory: () => (analytics, properties) =>
      setUserProperties(analytics, properties),
  },
);
